<template>
	<div class="notification content">
		<component :is="href('/interactions/web/details').content" />
		<div class="legend">
			<div class="entry direct">
				<div class="label">Direct</div>
				<div v-if="legend.direct > 0" class="value">{{ legend.direct }}%</div>
			</div>
			<div class="entry search">
				<div class="label">Search</div>
				<div v-if="legend.search > 0" class="value">{{ legend.search }}%</div>
			</div>
			<div class="entry social">
				<div class="label">Social</div>
				<div v-if="legend.social > 0" class="value">{{ legend.social }}%</div>
			</div>
			<div class="entry display">
				<div class="label">Display</div>
				<div v-if="legend.display > 0" class="value">{{ legend.display }}%</div>
			</div>
			<div class="entry referral">
				<div class="label">Referral</div>
				<div v-if="legend.referral > 0" class="value">{{ legend.referral }}%</div>
			</div>
			<div class="entry message">
				<div class="label">Message</div>
				<div v-if="legend.message > 0" class="value">{{ legend.message }}%</div>
			</div>
			<div class="entry other">
				<div class="label">Other</div>
				<div v-if="legend.other > 0" class="value">{{ legend.other }}%</div>
			</div>
		</div>
	</div>
</template>

<script>
import hreflang from "@/lib/hreflang";

export default {
	name: "WebInteraction",
    mixins: [hreflang],
    data() {
		return {
			legend: {
            },
		}
	},
	created() {
		this.document(require("documents/en/interactions/web-details.md"), "en");
	},
};
</script>

<style scoped lang="less">
@import url("~whitebox-presentation/src/assets/variables.less");
@import url("~whitebox-presentation/src/assets/mixins.less");
@import url("~whitebox-presentation/src/assets/legend.less");

.legend {
    margin-top: @gap;
}
</style>
